import { useState } from "react"

export const VariableRequests =() => {
    const [state, setState] = useState({
        requester_id: "",
        request_date: '',
        needed_on: '',
        notes:"",
        warehouse_id: "",
        received_by: "",
        phone_number: "",
        company_project_id: "",
        status:"",
        request_number: "",
        ship_to: "",
        location: "",
        items: [{
            material_id: "",
            qty: "",
            notes: ""
        }],
        files: [{
            file_path: "",
            type: "",
            notes: ""
        }],
        delivery_number: '',
        receiver:{
            delivery_number: '',
            received_by: '',
            received_on: '',
            phone_number: '',
            notes: '',
            sn: '',
            photo_identification:''
        },
        open: false,
        openEdit: false,
        arr1: [],
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setStateCustom1 = (variableName, value) => {
        console.log(variableName)
        const [parentKey, childKey] = variableName.split('.'); // تقسيم الاسم إلى جزئين بناءً على النقطة
        setState((prevState) => ({
            ...prevState,
            [parentKey]: {
                ...prevState[parentKey], // الحفاظ على البيانات السابقة في الوالد
                [childKey]: value, // تعيين القيمة الجديدة في الابن
            },
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const setOpen = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            open: value,
        }));
    };
    const setopenEdit = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            openEdit: value,
        }));
    };
    const handleEdit= (event, arr) => {
        event.preventDefault();
        setState((prevState) => ({
            ...prevState,
            arr1: arr,
            openEdit: true
        }));
    }
  return {
    ...state,
    state,
    setState,
    handleEdit,
    setOpen,
    setopenEdit,
    setStateCustom,setStateCustom1,
    setLoad
  }
}
